import Base from "components/Creation/components/Base";
import { useEffect, useState } from "react";
import BubbleChoices from "./components/BubbleChoices";
import useSelection from "hooks/useSelection";
import Warning from "../Warning";
import { useHistory } from "react-router-dom";
import MirumModal from "components/MirumModal";
import { Animated } from "react-animated-css";

const Anything = () => {
  const history = useHistory();
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const [selected, setSelected] = useState({
    vibe: [],
    accessibility: [],
    fromLondon: [],
    notes: "",
  });
  const { setSelectionForKey, redirectIfNotValidUpUntilKey, keyIsValidated } =
    useSelection({
      key: "anything",
      setter: setSelected,
    });

  useEffect(() => {
    redirectIfNotValidUpUntilKey("anything");
  }, []);

  const bubbleClassName = "rounded-sm md:rounded-full";

  return (
    <Base
      title="Anything Else?"
      footerOnClickedNext={() => {
        if (!keyIsValidated("anything")) {
          setShowErrorMsg(true);
        } else {
          history.push("/budget");
        }
      }}
    >
      <MirumModal
        show={showErrorMsg}
        onPositiveBtnClick={() => {
          setShowErrorMsg(false);
        }}
        onDidDismiss={() => {
          setShowErrorMsg(false);
        }}
        hideNegativeBtn={true}
      >
        <div>
          <h1>tell us more</h1>
          <p className="my-4">
            please ensure you've answered all questions and added any applicable
            notes
          </p>
        </div>
      </MirumModal>
      <div className="container mx-auto grow items-center flex flex-col justify-center z-10 py-8">
        <div className=" grid grid-cols-1 md:flex w-full md:w-11/12 mx-auto text-center items-end gap-8">
          <div className="md:w-[42.857%] px-4">
            <div className="block">
              <BubbleChoices
                availableItems={["casual", "smart-casual", "dressy"]}
                selectedItems={selected.vibe}
                onSelectedItems={(items) =>
                  setSelectionForKey({ ...selected, vibe: items })
                }
                title="Vibe"
                className="grid-cols-2 md:grid-cols-3"
              />
            </div>
          </div>
          <div className="md:w-[28.571%] px-4">
            <div className="block">
              <BubbleChoices
                mode="single"
                availableItems={["yes", "no"]}
                selectedItems={selected.accessibility}
                onSelectedItems={(items) =>
                  setSelectionForKey({ ...selected, accessibility: items })
                }
                className="grid-cols-2"
                title="Accessibility"
              />
            </div>
          </div>
          <div className="md:w-[28.571%] px-4">
            <div className="block">
              <BubbleChoices
                mode="single"
                availableItems={["yes", "no"]}
                selectedItems={selected.fromLondon}
                onSelectedItems={(items) =>
                  setSelectionForKey({ ...selected, fromLondon: items })
                }
                className="grid-cols-2"
                title="Are you from London?"
              />
            </div>
          </div>
        </div>
        {selected.vibe.length > 0 &&
          selected.accessibility.length > 0 &&
          selected.fromLondon.length > 0 && (
            <div className="w-full text-center mt-8">
              {/* {selected.accessibility.indexOf("yes") > -1 && (
                <Animated animationIn="fadeInUp">
                  <div className="hidden md:block shadow-xl bg-white py-4 px-8 inline-block mx-auto rounded-xl border-sm border-[#F9F9F9] text-black">
                    <p className="text-black lowercase">
                      Accessibility Required: Please provide additional details
                      below.
                    </p>
                  </div>
                </Animated>
              )} */}
              <h3 className="mt-4 lowercase" style={{ color: "#7994FF" }}>
                Please provide additional details below
              </h3>
              <p className="m-4">
                (exclusions / special occasions / accessibility requirements
                etc.)
              </p>
              <textarea
                className={`w-full md:w-6/12 mx-auto rounded-lg ${
                  selected.accessibility.indexOf("yes") > -1 &&
                  (!selected.notes || selected.notes?.length <= 2)
                    ? "border-[var(--blue)]"
                    : ""
                }`}
                value={selected.notes}
                onChange={(e) => {
                  setSelectionForKey({
                    ...selected,
                    notes: e.target.value,
                  });
                }}
                placeholder="e.g. no confined spaces. it’s for a birthday meal. nothing to do with heights"
              />
            </div>
          )}
        {!keyIsValidated("anything") && (
          <div className="mt-8">
            <Warning msg="please ensure you've answered all questions and added any applicable notes" />
          </div>
        )}
      </div>
    </Base>
  );
};

export default Anything;
